import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  constructor(private restService: RestService) {}

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('services/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('product/edit', val_id);
  }

  updateSave(data: any) {
    return this.restService.save('services/update/save', data);
  }

  save(data: any) {
    return this.restService.save('services/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('services/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('services/delete', val_id);
  }
}
